module.exports = __webpack_public_path__ + "static/img/20180414165942.8f59ae61.jpg";